"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RequestAccessModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestAccessModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../dsl/backoffice");
const form_1 = require("../_abstract/form");
const form_2 = require("../_components/form");
const _contracts_1 = require("../_contracts");
const RequestAccess_config_1 = require("./RequestAccess.config");
/**
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 * @author Rafał Żak <rafal.zak@movecloser.pl>
 */
let RequestAccessModuleForm = RequestAccessModuleForm_1 = class RequestAccessModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        this.icons = backoffice_1.DashmixIconName;
        this.isLoading = false;
        this.events = [];
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = RequestAccessModuleForm_1.getInitialContent();
    }
    /**
     * Function to check if header exist
     *
     * @return boolean
     */
    get hasHeader() {
        return this._content.header !== null;
    }
    /**
     * Function to set header according to hasHeader value
     */
    set hasHeader(value) {
        if (!value) {
            this._content.header = null;
            return;
        }
        this._content.header = {
            small: null,
            intro: {
                isBold: false,
                text: null
            },
            large: null
        };
    }
    onEventUpdate(uuid) {
        this._content.uuid = uuid;
    }
    /**
     * TODO: Doc
     */
    async loadEvents() {
        throw new Error('Implement in children');
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.RequestAccess,
            size: {
                colSpan: 6,
                rowSpan: 1,
                isResizable: false,
                maxColSpan: 6,
                minColSpan: 6,
                minRowSpan: 1,
                maxRowSpan: 1
            }
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return RequestAccess_config_1.initialContent;
    }
};
RequestAccessModuleForm = RequestAccessModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'RequestAccessModuleForm',
        components: {
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixInput: backoffice_1.DashmixInput,
            DashmixSelect: backoffice_1.DashmixSelect,
            DashmixTextArea: backoffice_1.DashmixTextArea,
            FormErrors: form_2.FormErrors,
            ModuleHeaderForm: form_2.ModuleHeaderForm
        },
        mounted() {
            this.loadEvents();
        },
        template: `
    <div>
    <label for="type" class=" mt-4 d-block">{{ $t('forms.shared.type.label') }}</label>
    <DashmixSelect class="mb-2" :model="_content.uuid" @update:model="onEventUpdate" :options="events"
                   :disabled="isLoading"/>

    <div class="mb-4 mt-4">
      <label for="options">Pokaż dodatkowe pola w formularzu</label>
      <DashmixCheck class="pb-2" :label="$t('_.phone-number')" name="hasPhone"
                    :model.sync="_content.phone"/>

      <DashmixCheck class="pb-2" :label="$t('_.title')" name="hasTitle"
                    :model.sync="_content.title"/>

      <DashmixCheck class="pb-2" :label="$t('_.organization')" name="hasOrganization"
                    :model.sync="_content.organization"/>

      <!-- Role -->
      <DashmixCheck class="pb-2" :label="$t('_.role')" name="hasRole"
                    :model.sync="_content.role"/>

      <!-- VAT -->
      <DashmixCheck class="pb-2" :label="$t('_.vatId')" name="hasVatId"
                    :model.sync="_content.vatId"/>

      <!-- Permission One -->
      <DashmixCheck class="pb-2" :label="$t('_.permission')" name="hasPermissionOne"
                    :model.sync="_content.permissionOne"/>

      <DashmixInput v-if="_content.permissionOne" name="permissionOne"
                      autocomplete="vat-id" :required="false"
                      :model.sync="_content.permissionOneValue"
                      :placeholder="$t('_.permissionValue')"/>

      <!-- Permission Two -->
      <DashmixCheck class="pb-2" :label="$t('_.permission')" name="hasPermissionTwo"
                    :model.sync="_content.permissionTwo"/>

      <DashmixInput v-if="_content.permissionTwo" name="permissionTwo"
                      :required="false" :model.sync="_content.permissionTwoValue"
                      :placeholder="$t('_.permissionValue')"/>

      <!-- Permission Three -->
      <DashmixCheck class="pb-2" :label="$t('_.permission')" name="hasPermissionThree"
                    :model.sync="_content.permissionThree"/>

      <DashmixInput v-if="_content.permissionThree" name="permissionThree"
                      :required="false" :model.sync="_content.permissionThreeValue"
                      :placeholder="$t('_.permissionValue')"/>

      <!-- Permission Four -->
      <DashmixCheck class="pb-2" :label="$t('_.permission')" name="hasPermissionFour"
                    :model.sync="_content.permissionFour"/>

      <DashmixInput v-if="_content.permissionFour" name="permissionFour"
                      :required="false" :model.sync="_content.permissionFourValue"
                      :placeholder="$t('_.permissionValue')"/>
      <!-- Additional information -->
      <div class="form-group">
        <label for="anchor" class="d-block">{{ $t('forms.requestAccess.additionalInformation.label') }}
          <abbr :title="$t('forms.requestAccess.additionalInformation.abbr')">?</abbr>
        </label>
        <DashmixTextArea :model.sync="_content.additionalInformation" name="additionalInformation"
                         :placeholder="$t('forms.requestAccess.additionalInformation.placeholder')"/>
      </div>
      <!-- Anchor | END -->
    </div>
    <!-- Header -->
    <DashmixCheck class="pb-2" :label="$t('forms.shared.hasHeader')" name="hasHeader"
                  :model.sync="hasHeader"/>

    <ModuleHeaderForm v-if="hasHeader" :data.sync="_content.header"/>
    <!-- Header| END -->

    <!-- Background -->
    <div class="form-group">
      <label for="background" class="d-block">{{ $t('forms.shared.background.label') }}</label>
      <DashmixInput :model.sync="_content.background" name="background"
                    :placeholder="$t('forms.shared.background.placeholder')"/>
    </div>
    <!-- Background | END -->

    <!-- Anchor -->
    <div class="form-group">
      <label for="anchor" class="d-block">{{ $t('forms.requestAccess.anchor.label') }}
        <abbr :title="$t('forms.requestAccess.anchor.abbr')">?</abbr>
      </label>
      <DashmixInput :model.sync="_content.anchor" name="anchor"
                    :placeholder="$t('forms.requestAccess.anchor.placeholder')"/>
    </div>
    <!-- Anchor | END -->

    <!-- Form errors -->
    <FormErrors v-if="errors" v-bind="{ errors }" class="mt-3"/>
    </div>`
    })
], RequestAccessModuleForm);
exports.RequestAccessModuleForm = RequestAccessModuleForm;
//# sourceMappingURL=RequestAccess.form.js.map